const SELECTORS = {
  PRICING_TABLE: ".pricing-table__wrapper",
  HEADER: ".pricing-table__header div",
  FEATURES_TABLE: ".feature-table",
  FREE_TABLE: ".pricing-table--free",
  PREMIUM_TABLE: ".pricing-table--premium",
  FEATURES: ".pricing-table__features",
  MAILCHIMP_FORM: ".mailchimp-form",
  EMAIL_INPUT: ".sign-up__input",
  NAV: ".navigation",
  NAV_LINK: ".navigation__link",
  NAV_TOGGLE: ".navigation__toggle",
  SIGN_UP: ".sign-up"
};

const STATES = {
  INPUT_ERROR: 'sign-up--error',
  SUBSCRIBE_SUCCESS: 'sign-up--success'
}

class Caddy {
  constructor() {
    console.log("caddy constructor");
  }

  init() {
    console.log("caddy init");

    //init pricing table
    this.pricingTable();

    this.mailChimpAjax();

    this.nav();

    //on resize rerun pricingtable
    window.onresize = () => this.pricingTable();

    inView.offset({
        bottom: 100,
    });

    inView('.iv-slide-up').on('enter', el => {
      el.style.top = 0;
    })

    inView('.iv-slide-in-left').on('enter', el => {
      el.style.left = 0;
      el.style.opacity = 1;
    })

    inView('.iv-stroke').on('enter', el => {
      el.classList.add('active');
    })

    inView('.iv-fade-in').on('enter', el => {
      el.style.opacity = 1;
    })

    $('a[href*="#"]').on('click', function(event) {

      let parts = $(this).attr('href').split('#');
      
          var target = $( `#${parts[1]}` );
      
          if( target.length && window.location.pathname ==  parts[0]) {
              event.preventDefault();
              $('html, body').animate({
                  scrollTop: target.offset().top
              }, 500);
          }
      
      });
  }

  nav() {
    $(SELECTORS.NAV_LINK).on("click", evt => {
      $(SELECTORS.NAV_TOGGLE).click();
    });
  }

  mailChimpAjax() {

    $(SELECTORS.EMAIL_INPUT).on("keyup", e => {
      if(e.keyCode != 13){
        $(SELECTORS.SIGN_UP).removeClass(STATES.INPUT_ERROR);
      }
    });

    $(SELECTORS.EMAIL_INPUT).on("invalid", () => {
      $(SELECTORS.SIGN_UP).addClass(STATES.INPUT_ERROR);
      return false;
    });



    $(SELECTORS.MAILCHIMP_FORM).submit(function(e) {
      e.preventDefault();

      $.ajax({
        url: $(SELECTORS.MAILCHIMP_FORM).attr("action") + "&c=?",
        type: "GET",
        data: $(SELECTORS.MAILCHIMP_FORM).serialize(),
        dataType: "jsonp",
        success: function({ result, msg }) {
          if (result == "success") {
            //hide input
            $(SELECTORS.EMAIL_INPUT).blur();
            $(SELECTORS.SIGN_UP).addClass(STATES.SUBSCRIBE_SUCCESS);
          }
        }
      });
    });
  }

  getMax(heights) {
    return heights
      .sort((a, b) => {
        return a - b;
      })
      .reverse()[0];
  }

  adjustRows(rows) {
    let heights = [];

    rows.forEach(row => {
      heights.push(row.clientHeight);
    });

    let biggest = this.getMax(heights);

    rows.forEach(row => {
      row.style.height = biggest + "px";
    });
  }

  clearInlineHeights() {
    let rows = document.querySelectorAll(`${SELECTORS.FEATURES} div`);
    rows.forEach(row => {
      row.style.height = "";
    });

    rows = document.querySelectorAll(`${SELECTORS.HEADER}`);
    rows.forEach(row => {
      row.style.height = "";
    });
  }

  pricingTable() {
    let table = document.querySelector(SELECTORS.PRICING_TABLE);

    if (window.innerWidth < 768) {
      return this.clearInlineHeights();
    }

    this.clearInlineHeights();

    //Caluclaute max header size
    let headers = document.querySelectorAll(SELECTORS.HEADER, table);
    this.adjustRows(headers);

    //calculate feature heights
    let features = document.querySelectorAll(
      `${SELECTORS.FEATURES_TABLE} ${SELECTORS.FEATURES} div`,
      table
    );
    let freeFeatures = document.querySelectorAll(
      `${SELECTORS.FREE_TABLE} ${SELECTORS.FEATURES} div`,
      table
    );
    let premiumFeatures = document.querySelectorAll(
      `${SELECTORS.PREMIUM_TABLE} ${SELECTORS.FEATURES} div`,
      table
    );

    //Find adjacent rows
    for (let i = 0; i < features.length; i++) {
      this.adjustRows([features[i], freeFeatures[i], premiumFeatures[i]]);
    }
  }
}

const caddy = new Caddy();
